import { useTranslation } from "react-i18next";
import EnLogo from "../../assets/svg/logo/Sabeqoon_Logo_Logo.svg";
import ArLogo from "../../assets/svg/logo/Sabeqoon_Logo_Logo_Arabic.svg";

export const Logo = ({ width }) => {
  const { i18n } = useTranslation();
  const logoSrc = i18n.dir() === 'ltr' ? EnLogo : ArLogo;

  return (
    <img src={logoSrc} alt="Sabeqoon logo" width={width}></img>
  )
}
